const structuredData = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  inLanguage: "en",
  name: "AppAdvisor Steps",
  description: "AppAdvisor Steps",
  itemListElement: [
    {
      "@type": "Article",
      name: "Realize the potential of building with Microsoft",
      headline: "Realize the potential of building with Microsoft",
      description:
        "Build powerful apps, faster. Developers and companies choose Microsoft for powerful integrated technology stacks, intuitive dev tools, industry-leading security and Responsible AI across all development stages. Microsoft technology and AI-native services offer software development companies an intelligent, robust, scalable, integrated, and secure platform with:",
      keywords:
        "Next-gen AI, Integrated AI-native tools, Seamless, efficient integration and scale, End-to-end security",
      url: "https://cm-edgetun.pages.dev/software-development-companies/app-advisor/guidance/my-results?stage=discover&step=realize-the-potential-of-building-with-microsoft",
    },
    {
      "@type": "Article",
      name: "Sell more with Microsoft Marketplace",
      headline: "Sell more with Microsoft Marketplace",
      description:
        "Sell your apps and agents to millions of potential customers globally to surface your app or agent through Microsoft Marketplace, as well as in-product experiences like the Azure portal, Agent Store, Teams Store, Dynamics 365 and more, where your customers are looking to buy.",
      keywords:
        "Azure portal, Agent Store, Teams Store, Dynamics 365",
      url: "https://cm-edgetun.pages.dev/software-development-companies/app-advisor/guidance/my-results?stage=discover&step=sell-more-with-microsoft-marketplace",
    },
  ],
};

export default structuredData;